<template>
    <rkm-overlay>
        <rkm-layout-body title="Lista de opção de chamada">
            <template v-slot:actions>
                <rkm-button
                    @click="$router.push({ name: 'painel-senha-opcao-chamada-create' })"
                    color="primary"
                    authorize="store-painel-senha-opcao-chamada"
                >
                    Cadastrar opção de chamada
                </rkm-button>
            </template>

            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/painel-senha/opcao-chamada/List'

export default {
    components: { List },
}
</script>